import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=1e8536a3"
import script from "./_slug.vue?vue&type=script&lang=js"
export * from "./_slug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Post: require('/vercel/path0/components/post.vue').default,Page: require('/vercel/path0/components/page.vue').default})
